import { Navigate, useSearchParams } from "react-router-dom";

// Backward-compatible: /apply?service=itr-filing → /apply/itr-filing
export default function ApplyRedirect() {
  const [params] = useSearchParams();
  const slug = params.get("service");
  const plan = params.get("plan");
  if (!slug) return <Navigate to="/services" replace />;
  const qs = plan ? `?plan=${encodeURIComponent(plan)}` : "";
  return <Navigate to={`/apply/${slug}${qs}`} replace />;
}
